module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 justify-end pb-0"
  }, [_c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("mdi-window-close")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 text-uppercase justify-center pt-0 pb-0"
  }, [_vm._v("Request VideoAmp Audience")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0 mb-5"
  }, [_c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonClicked),
      expression: "buttonClicked"
    }],
    attrs: {
      "indeterminate": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-autocomplete', {
    staticClass: "ma-12",
    attrs: {
      "items": _vm.items,
      "item-text": "name",
      "item-value": "id",
      "label": "VideoAmp Audience",
      "menu-props": {
        maxWidth: 396
      },
      "dense": "",
      "clearable": "",
      "item-disabled": function (item) { return item.disabled; },
      "search-input": _vm.search
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "input": function (val) { return _vm.$emit('update', val); }
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center pb-8"
  }, [_c('action-button', {
    attrs: {
      "light": "",
      "disabled": _vm.disableRequestAudience,
      "label": "Submit",
      "color": "primary",
      "id": "requestVideoAmpAudienceBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestAudience.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9ca50ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/videoampSegment/RequestVideoAmpSegment.vue
// module id = 1998
// module chunks = 0